import { withStyles } from '@material-ui/core/styles';
import CalendarRange from './Calendar';
import styles from './Calendar.styles';

export default withStyles(styles)(CalendarRange);
